<div class="vh-100 mt-5">
    <div id="loginCard" class="card p-4 shadow border-1 w-75 m-auto" *ngIf="!loading">
        <form [formGroup]="loginForm" id="loginForm" (ngSubmit)="onSubmit()" [hidden]="loading" autocomplete="off" class="needs-validation">
            <div class="row d-flex flex-column align-items-center">
                <div class="col-xs-12 text-center mb-3">
                    <img src="/dist/browser/images/logo_login.gif" id="logo" class="img-responsive" />
                </div>
                <div class="row mb-3" [hidden]="!invalidLogin">
                    <div class="alert alert-danger">
                        Invalid Username or Password
                    </div>
                </div>
                <div class="row mb-3" [hidden]="!restrictLogin">
                    <div class="alert alert-danger">
                        You have been restricted from logging in. Please try again in a few minutes.
                    </div>
                </div>
                <div class="col-12 mb-2">
                    <label class="form-label">Username</label>
                    <div class="input-group">
                        <span class="input-group-text">
                            <img style="width:20px" src="/dist/browser/images/user.png" />
                        </span>
                        <input type="text" class="form-control" [class.is-invalid]="loginForm.controls.username.invalid && loginForm.controls.username.dirty" formControlName="username" required placeholder="Username" autocomplete="new-password" tabindex="1" />
                    </div>
                    <div class="invalid-feedback">
                        <b *ngIf="(loginForm.controls.username.invalid && showError)">Username required.</b>
                    </div>
                </div>

                <div class="col-xs-12 mb-2">
                    <label class="form-label">Password</label>
                    <div class="input-group">
                        <span class="input-group-text">
                            <img style="width:20px" src="/dist/browser/images/password.png" />

                        </span>

                        <input type="password" class="form-control" [class.is-invalid]="loginForm.controls.password.invalid && loginForm.controls.password.dirty" formControlName="password" required placeholder="Password" autocomplete="new-password" tabindex="2" />

                    </div>
                    <div class="invalid-feedback">
                        <b *ngIf="(loginForm.controls.password.invalid && showError)">Password required.</b>
                    </div>
                </div>
                <div class="col-xs-12">
                    <p style="font-size:12px">
                        <small>
                            If you have any questions, please email <a href="mailto:devprojects@autoland.com">devproject&#64;autoland.com</a> or call (800) 234-6999
                        </small>

                    </p>
                </div>
                <div class="col-12 text-center">

                    <button type="submit"
                            [disabled]="loggingIn || loginForm.invalid || restrictLogin"
                            id="sign-in-btn"
                            tabindex="3">
                        Sign In
                        <img *ngIf="loggingIn" style="width:20px" src="/dist/browser/images/loader.gif" />
                    </button>

                </div>

            </div>

        </form>
    </div>
</div>




